export default "__VITE_ASSET__BVYt3rmN__"